import React from 'react';
import { UserIcon } from 'lucide-react';
/**
 * Account trigger. Wired to the platform's native account UI on import —
 * no stub navigation here, so this stays a real <button>.
 */
export function Account() {
  return <button type="button" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2 text-sm font-semibold" aria-label="Account" data-id="element-63">
      <UserIcon className="w-5 h-5" data-id="element-64" />
      <span data-id="element-65">Account</span>
    </button>;
}